import { IapService } from '../../services/iap.service';
import { Team } from '../../models/team.model';
import { User } from '../../services/auth.service';
import {
  Router,
  ActivatedRoute,
  UrlTree,
  UrlSegmentGroup,
  PRIMARY_OUTLET,
} from '@angular/router';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TeamsService } from '../../services/teams.service';
import { ToastController, IonInput, ModalController } from '@ionic/angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { AppTrial } from '../../models/app-trial.model';
import { ActionSheetController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
import { RenameModal } from '../rename-modal/rename-modal';
import { AnalyticsService } from '../../services/analytics.service';
import { environ } from '../../app.config';

@Component({
  selector: 'member-line-item',
  templateUrl: './member-line-item.component.html',
  styleUrls: ['./member-line-item.component.scss'],
})
export class MemberLineItemComponent implements OnInit, OnChanges {
  @Input() user: User;
  @Input() team: any;
  @Input() member: any;
  debug = false;

  memberType: string;
  environment = environ;

  constructor(
    private analytics: AnalyticsService,
    public alertController: AlertController,
    private teamsService: TeamsService,
    public modalCtrl: ModalController,
    public translate: TranslateService,
    public toastController: ToastController,
    public actionSheetController: ActionSheetController,
    public router: Router
  ) {
    if (this.environment === 'local') {
      this.debug = true;
    }
    const tree: UrlTree = this.router.parseUrl(
      this.router.routerState.snapshot.url
    );
    const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
    this.memberType = g.segments[0].path;
    console.log('Member Type:', this.memberType);
  }

  ngOnInit() {
    console.log('memberLineItem - ngOnInit()');
    console.log('member:  ', this.member);
  }

  ngOnChanges() {
    console.log('memberLineItem - ngOnInit()');
    console.log('member:  ', this.member);
  }

  async memberActionSheet() {
    console.log('memberActionSheet for:', this.member, this.team);
    this.analytics.track('qt_member_options', {
      team_id: this.team.teamId,
      member_status: this.member.status,
      member_id: this.member.memberId,
      ui: true,
    });

    if (this.member.status === 'unsubscribed') {
      this.analytics.track('qt_member_options_unsubscribed', {
        team_id: this.team.teamId,
        member_status: this.member.status,
        member_id: this.member.memberId,
      });
      return;
    }

    const member = this.member;

    const options = {
      header: `${this.translate.instant(
        this.memberType === 'staff'
          ? 'STAFF.LABELS.MEMBER_OPTIONS'
          : 'MEMBERS.LABELS.MEMBER_OPTIONS'
      )}:`,
      subHeader: `${member.firstName} ${member.lastName}`,
      buttons: [],
    };
    options.buttons.push({
      text: this.translate.instant(
        this.memberType === 'staff'
          ? 'STAFF.ACTIONS.EDIT_STAFF'
          : 'MEMBERS.ACTIONS.EDIT_MEMBER'
      ),
      handler: () => {
        console.log('Edit name');
        this.analytics.track('qt_member_options_edit', {
          team_id: this.team.teamId,
          member_status: this.member.status,
          member_id: this.member.memberId,
          ui: true,
        });
        this.editMemberModal();
      },
    });

    if (
      (this.memberType === 'members' &&
        (member.status === 'invited' || member.status === 'reinvited')) ||
      (this.memberType === 'staff' && !this.isUserAdmin())
    ) {
      options.buttons.splice(0, 0, {
        text: this.translate.instant(
          this.memberType === 'staff'
            ? 'STAFF.ACTIONS.RESEND_INVITE'
            : 'MEMBERS.ACTIONS.RESEND_INVITE'
        ),
        // role: 'destructive',
        // icon: 'trash',
        handler: () => {
          console.log('Resend invite clicked');
          this.analytics.track('qt_member_options_invite_resend', {
            team_id: this.team.teamId,
            member_status: this.member.status,
            member_id: this.member.memberId,
            ui: true,
          });
          this.teamsService.memberReinvite(
            member,
            this.memberType,
            this.team.teamId,
            this.team.messagesStatus.latest
          );
        },
      });
      options.buttons.splice(options.buttons.length, 0, {
        text: this.translate.instant(
          this.memberType === 'staff'
            ? 'STAFF.ACTIONS.REMOVE_INVITE'
            : 'MEMBERS.ACTIONS.REMOVE_INVITE'
        ),
        // role: 'destructive',
        // icon: 'trash',
        handler: () => {
          this.analytics.track('qt_member_options_invite_remove', {
            team_id: this.team.teamId,
            member_status: this.member.status,
            member_id: this.member.memberId,
            ui: true,
          });
          this.teamsService.teamRemoveMemberInvitation(
            this.member.memberId,
            this.memberType
          );
        },
      });
      if (this.debug)
        options.buttons.splice(options.buttons.length, 0, {
          text: 'Accept Invite',
          // role: 'destructive',
          // icon: 'trash',
          handler: () => {
            console.log('Accept invite clicked');
            this.mockResponse('YES');
          },
        });
    } else {
      if (this.memberType === 'members') {
        if (member.status === 'active') {
          options.buttons.splice(options.buttons.length, 0, {
            text: this.translate.instant('MEMBERS.ACTIONS.REMOVE_MEMBER'),
            // role: 'destructive',
            // icon: 'trash',
            handler: () => {
              console.log('Remove member clicked');
              this.analytics.track('qt_member_options_member_remove', {
                team_id: this.team.teamId,
                member_status: this.member.status,
                member_id: this.member.memberId,
                ui: true,
              });
              this.confirmRemove(member, this.memberType);
            },
          });
        }
        if (member.status === 'removed') {
          options.buttons.splice(options.buttons.length, 0, {
            text: this.translate.instant('MEMBERS.ACTIONS.RESTORE_MEMBER'),
            // role: 'destructive',
            // icon: 'trash',
            handler: () => {
              console.log('Restore member clicked');
              this.analytics.track('qt_member_options_member_restore', {
                team_id: this.team.teamId,
                member_status: this.member.status,
                member_id: this.member.memberId,
                ui: true,
              });
              this.teamsService.memberRemove(member, this.memberType);
            },
          });
        }
      }
      if (
        this.memberType === 'staff' &&
        this.user.uid !== member.mobileNumber.full
      ) {
        options.buttons.splice(options.buttons.length, 0, {
          text: this.translate.instant('STAFF.ACTIONS.REMOVE_STAFF'),
          // role: 'destructive',
          // icon: 'trash',
          handler: () => {
            console.log('Remove member clicked');
            this.analytics.track('qt_member_options_staff_remove', {
              team_id: this.team.teamId,
              staff_status: this.member.status,
              staff_id: this.member.memberId,
              ui: true,
            });
            this.confirmRemove(member, this.memberType);
          },
        });
      }
    }
    if (
      this.isUserAdmin() && // Logged in user is team admin
      this.memberType === 'staff' && // User is on staff list (not team members)
      !this.isMemberAdmin() // Clicked staff is not already the team admin
    ) {
      options.buttons.splice(options.buttons.length, 0, {
        text: this.translate.instant('STAFF.ACTIONS.GRANT_ADMINISTRATION'),
        // role: 'destructive',
        // icon: 'trash',
        handler: () => {
          console.log('Grant administration clicked');
          this.analytics.track('qt_member_options_grant_admin', {
            team_id: this.team.teamId,
            member_status: this.member.status,
            member_id: this.member.memberId,
            ui: true,
          });
          this.confirmGrant(this.team, member);
        },
      });
    }
    options.buttons.push({
      text: this.translate.instant(
        this.memberType === 'staff'
          ? 'STAFF.ACTIONS.CANCEL'
          : 'MEMBERS.ACTIONS.CANCEL'
      ),
      // icon: 'close',
      // role: 'cancel',
      handler: () => {
        console.log('Member options cancelled');
        this.analytics.track('qt_member_options_cancel', {
          team_id: this.team.teamId,
          member_status: this.member.status,
          member_id: this.member.memberId,
          ui: true,
        });
      },
    });
    const actionSheet = await this.actionSheetController.create(options);
    await actionSheet.present();
  }

  mockResponse(response) {
    this.teamsService.teamMemberMockResponse(
      this.member.mobileNumber.full,
      this.team.teamPhoneFull,
      response
    );
  }

  async confirmRemove(member, memberType) {
    const alert = await this.alertController.create({
      header: this.translate.instant(
        this.memberType === 'staff'
          ? 'STAFF.DIALOGS.REMOVE_STAFF.TITLE'
          : 'MEMBERS.DIALOGS.REMOVE_MEMBER.TITLE'
      ),
      message: `${member.firstName} ${member.lastName} ${this.translate.instant(
        this.memberType === 'staff'
          ? 'STAFF.DIALOGS.REMOVE_STAFF.CAPTION'
          : 'MEMBERS.DIALOGS.REMOVE_MEMBER.CAPTION'
      )}`,
      buttons: [
        {
          text: this.translate.instant(
            this.memberType === 'staff'
              ? 'STAFF.DIALOGS.REMOVE_STAFF.BUTTONS.CANCEL'
              : 'MEMBERS.DIALOGS.REMOVE_MEMBER.BUTTONS.CANCEL'
          ),
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Archive cancelled');
            this.analytics.track('qt_member_remove_cancel', {
              team_id: this.team.teamId,
              member_status: this.member.status,
              member_id: this.member.memberId,
              member_type: this.memberType,
              ui: true,
            });
          },
        },
        {
          text: this.translate.instant(
            this.memberType === 'staff'
              ? 'STAFF.DIALOGS.REMOVE_STAFF.BUTTONS.REMOVE'
              : 'MEMBERS.DIALOGS.REMOVE_MEMBER.BUTTONS.REMOVE'
          ),
          handler: () => {
            console.log('Remove confirmed');
            this.analytics.track('qt_member_remove_confirm', {
              team_id: this.team.teamId,
              member_status: this.member.status,
              member_id: this.member.memberId,
              member_type: this.memberType,
              ui: true,
            });
            this.teamsService.memberRemove(member, memberType);
          },
        },
      ],
    });

    await alert.present();
  }

  async confirmGrant(team, member) {
    const alert = await this.alertController.create({
      header: this.translate.instant('TEAMS.DIALOGS.GRANT_TEAM.TITLE'),
      message: `${team.teamName} ${this.translate.instant(
        'TEAMS.DIALOGS.GRANT_TEAM.CAPTION'
      )}`,
      buttons: [
        {
          text: this.translate.instant(
            'TEAMS.DIALOGS.GRANT_TEAM.BUTTONS.CANCEL'
          ),
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Grant team cancelled');
            this.analytics.track('qt_member_grant_cancel', {
              team_id: this.team.teamId,
              member_status: this.member.status,
              member_id: this.member.memberId,
              member_type: this.memberType,
              ui: true,
            });
          },
        },
        {
          text: this.translate.instant(
            'TEAMS.DIALOGS.GRANT_TEAM.BUTTONS.GRANT'
          ),
          cssClass: 'warning',
          handler: () => {
            console.log('Grant team confirmed');
            this.analytics.track('qt_member_grant_confirm', {
              team_id: this.team.teamId,
              member_status: this.member.status,
              member_id: this.member.memberId,
              member_type: this.memberType,
              ui: true,
            });
            this.teamsService.teamGrant(team, member.mobileNumber.full);
          },
        },
      ],
    });

    await alert.present();
  }

  async removedActionSheet() {
    const options = {
      header: `${this.translate.instant(
        this.memberType === 'staff'
          ? 'STAFF.LABELS.STAFF_OPTIONS'
          : 'MEMBERS.LABELS.MEMBER_OPTIONS'
      )}:`,
      subHeader: `${this.member.firstName} ${this.member.lastName}`,
      buttons: [
        {
          text: this.translate.instant(
            this.memberType === 'staff'
              ? 'STAFF.ACTIONS.RESTORE_STAFF'
              : 'MEMBERS.ACTIONS.RESTORE_MEMBER'
          ),
          // role: 'destructive',
          // icon: 'trash',
          handler: () => {
            console.log('Restore member clicked');
            this.analytics.track('qt_member_restore_confirm', {
              team_id: this.team.teamId,
              member_status: this.member.status,
              member_id: this.member.memberId,
              member_type: this.memberType,
              ui: true,
            });
            this.teamsService.memberRestore(this.member, this.memberType);
          },
        },
        {
          text: this.translate.instant(
            this.memberType === 'staff'
              ? 'STAFF.ACTIONS.CANCEL'
              : 'MEMBERS.ACTIONS.CANCEL'
          ),
          // icon: 'close',
          role: 'cancel',
          handler: () => {
            console.log('Member options cancelled');
            this.analytics.track('qt_member_restore_cancel', {
              team_id: this.team.teamId,
              member_status: this.member.status,
              member_id: this.member.memberId,
              member_type: this.memberType,
              ui: true,
            });
          },
        },
      ],
    };
    const actionSheet = await this.actionSheetController.create(options);
    await actionSheet.present();
  }

  isUserAdmin() {
    if (!this.user || !this.team) {
      return false;
    }
    const isAdmin =
      this.user.phone.full === this.team.teamAdminId ? true : false;
    return isAdmin;
  }

  isMemberAdmin() {
    return this.team.teamAdminId === this.member.mobileNumber.full
      ? true
      : false;
  }

  async editMemberModal() {
    const modal = await this.modalCtrl.create({
      component: RenameModal,
      componentProps: {
        action:
          this.memberType === 'staff'
            ? 'STAFF.ACTIONS.EDIT_STAFF'
            : 'MEMBERS.ACTIONS.EDIT_MEMBER',
        data: {
          team: this.team,
          memberType: this.memberType,
          member: this.member,
          op: 'edit',
        },
      },
    });
    return await modal.present();
  }
}
